import ProfileIcon from "@layouts/v4/authPopup/icons/ProfileIcon.jsx";
import SignUpIcon from "@layouts/v4/authPopup/icons/SignUpIcon.jsx";
import { Button } from "antd";
import React, { Component, Fragment } from "react";
import { getActiveLanguage, getLanguages, getTranslate } from "react-localize-redux";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import CloseIcon from "./Icons/CloseIcon.jsx";
import ErrorIcon from "./Icons/ErrorIcon.jsx";
import SuccessIcon from "./Icons/SuccessIcon.jsx";
import { hideAlert, toggleAuthPopup } from "./action";

const Modal = styled.div`
	position: fixed;
	z-index: 10001;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
		linear-gradient(0deg, rgba(255, 128, 47, 0.2) 0%, rgba(255, 128, 47, 0.2) 100%),
		linear-gradient(0deg, rgba(26, 27, 43, 0.6) 0%, rgba(26, 27, 43, 0.6) 100%),
		radial-gradient(50% 50% at 50% 50%, rgba(80, 46, 128, 0.07) 0%, rgba(0, 0, 0, 0.9) 100%);
	background-blend-mode: normal, color, normal, normal;
	backdrop-filter: blur(12.5px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 20px;

	svg {
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	${({ hasLessBorderRadiusAndColorful }) =>
		hasLessBorderRadiusAndColorful &&
		css`
			background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
				linear-gradient(0deg, rgba(47, 255, 179, 0) 0%, rgba(47, 255, 179, 0) 100%),
				linear-gradient(0deg, rgba(32, 37, 34, 0.6) 0%, rgba(32, 37, 34, 0.6) 100%),
				radial-gradient(
					50% 50% at 50% 50%,
					rgba(22, 41, 63, 0.6) 0%,
					rgba(0, 0, 0, 0.6) 100%
				);
			background-blend-mode: normal, color, normal, normal;
			backdrop-filter: blur(12.5px);

			${AlertWrapper} {
				box-shadow: 0px 0px 34px 0px rgba(51, 255, 109, 0.1);
				background: linear-gradient(
					180deg,
					rgba(2, 19, 21, 0.8) 9.72%,
					rgba(12, 49, 55, 0.8) 50.54%,
					rgba(3, 11, 17, 0.8) 100%
				);
			}

			${Title} {
				color: var(--modal-text-color);
			}

			svg {
				path {
					fill: var(--modal-text-color);
				}
			}

			${SignButtonWrapper} {
				.login-button,
				.sign-up-button {
					opacity: 0.6;
					border-radius: 10px;
				}

				.login-button {
					background: var(--sign-in-btn-bg);
					color: var(--button-color);
					opacity: 0.6;
					svg {
						path {
							fill: var(--button-color);
						}
					}
				}
				.sign-up-button {
					background: transparent;
					color: var(--sign-up-btn-text);
					opacity: 0.6;
					svg {
						path {
							fill: var(--sign-up-btn-text);
						}
					}
				}
			}
		`}
`;
Modal.displayName = "Modal";

const AlertWrapper = styled.div`
	width: 320px;
	border-radius: 25px;
	background: linear-gradient(180deg, #191726 0%, #050512 100%);
	min-height: 110px;
	padding: 20px;
	display: flex;
	align-items: center;
	flex-direction: column;
	position: relative;

	@media (min-width: 1024px) {
		width: 460px;
		padding: 30px;
	}
`;
AlertWrapper.displayName = "AlertWrapper";

const Title = styled.div`
	color: var(--main-color);
	text-align: center;
	text-transform: uppercase;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.75px;

	${({ type }) =>
		type &&
		css`
			color: ${type === "error" ? "var(--main-color)" : "#18BB0C"};
		`}
`;
Title.displayName = "Title";

const Msg = styled.div`
	text-align: center;
	color: var(--main-text-color);
	border-radius: 15px;
	${({ type }) =>
		type &&
		css`
			background: ${type === "error"
				? "linear-gradient(180deg, rgba(255, 159, 47, 0.10) 0%, rgba(216, 91, 0, 0.10) 100%)"
				: "linear-gradient(180deg, rgba(24, 187, 12, 0.10) 0%, rgba(6, 115, 6, 0.10) 100%)"};
		`}
	padding: 15px 20px;
	width: 100%;
	color: #eff0f6;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.75px;
`;
Msg.displayName = "Msg";

const ButtonWrapper = styled.div`
	position: absolute;
	height: 35px;
	width: 100%;
	bottom: -17px;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 80px;
`;
ButtonWrapper.displayName = "ButtonWrapper";

const AlertButton = styled.div`
	min-width: 100px;
	max-width: 100px;
	height: 35px;
	font-size: 14px;
	font-weight: 700;
	text-align: center;
	color: var(--main-text-color);
	border-radius: 17.5px;
	background-color: var(--main-explosive);
	-webkit-font-smoothing: antialiased;
	line-height: 35px;
	margin-right: 5px;
	cursor: pointer;
	&:last-child {
		margin-right: 0px;
	}
`;
AlertButton.displayName = "AlertButton";

const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 5px;
	margin-bottom: 10px;
`;
TitleWrapper.displayName = "TitleWrapper";

const SignButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 20px;
	gap: 10px;

	.login-button,
	.sign-up-button {
		min-width: 115px;
		width: 100%;
		height: 40px;
		color: #fff;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		border-radius: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 5px;
	}

	.login-button {
		background: var(--main-gradient);
	}

	.sign-up-button {
		background: var(--main-explosive-gradient);
	}
`;
TitleWrapper.displayName = "TitleWrapper";

class Alert extends Component {
	/**
	 * Constructor method
	 * @param {Object} props
	 */
	constructor(props) {
		super(props);
		this.state = {
			profileUpdateTimer: null,
		};
		setInterval(this.updateAlerts.bind(this), 1000);
		this.interval = 3000;
	}

	updateAlerts() {
		const d = new Date();
		let i = 0;
		for (let alert of this.props.alert.alerts) {
			if (!alert.persistent && d - alert.expiry > this.interval) {
				this.props.hideAlert(i);
			}
			i++;
		}
	}

	close(index) {
		if (this.state.profileUpdateTimer) {
			clearTimeout(this.state.profileUpdateTimer);
			this.setState({ profileUpdateTimer: null });
		}

		if (this.props.alert.alerts[index].callback) {
			this.props.alert.alerts[index].callback();
		}
		this.props.hideAlert(index);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.alert && !this.props.alert) {
			setTimeout(() => this.props.toggleAuthPopup(true, this.state.authType), 0);
		}

		const currentAlerts = this.props.alert?.alerts || [];
		const prevAlerts = prevProps.alert?.alerts || [];

		if (currentAlerts.length > prevAlerts.length) {
			const newAlert = currentAlerts[currentAlerts.length - 1];
			if (
				newAlert.msg === "PROFILE_UPDATE_REQUIRED_MESSAGE" &&
				!this.state.profileUpdateTimer
			) {
				const timer = setTimeout(() => {
					window.location.href = "/profile/settings";
				}, 10000);
				this.setState({ profileUpdateTimer: timer });
			}
		}
	}

	componentWillUnmount() {
		if (this.state.profileUpdateTimer) {
			clearTimeout(this.state.profileUpdateTimer);
		}
	}

	handleProfileUpdate(index) {
		this.close(index);
		window.location.href = "/profile/settings";
	}

	/**
	 * Render method
	 * @return {html} Html structure
	 */
	render() {
		const { translate, currentLanguage } = this.props;
		return (
			<Fragment>
				{this.props.children}

				{this.props.alert &&
					this.props.alert.alerts.map((x, index) => {
						return (
							<Modal
								hasLessBorderRadiusAndColorful={window.HAS_LESS_BORDER_RADIUS}
								key={`${index}-alert-item`}>
								<AlertWrapper key={`alert-key-${index}`}>
									<TitleWrapper>
										{x?.type === "error" ? <ErrorIcon /> : null}
										{x?.type === "success" ? <SuccessIcon /> : null}
										<Title type={x?.type}>
											{x.noTranslate ? x.title : translate(x.title)}
										</Title>
									</TitleWrapper>
									<Msg type={x?.type}>
										{x.noTranslate
											? x.msg.toLocaleUpperCase(
													currentLanguage === "tr" ? "tr-TR" : "en-US"
												)
											: x.msgParams
												? translate(x.msg, Object.assign({}, x.msgParams), {
														renderInnerHtml: true,
													}).toLocaleUpperCase(
														currentLanguage === "tr" ? "tr-TR" : "en-US"
													)
												: translate(x.msg).toLocaleUpperCase(
														currentLanguage === "tr" ? "tr-TR" : "en-US"
													)}
									</Msg>
									{x.msg === "LOGIN_OR_SIGNUP_FIRST" ||
									x.msg === "SESSION_END" ? (
										<SignButtonWrapper>
											<Button
												type="primary"
												htmlType="submit"
												className="login-button"
												onClick={() => {
													this.close(index);
													this.setState({ authType: "login" });
													this.props.toggleAuthPopup(true, "login");
												}}>
												<ProfileIcon /> {translate("signin-signup.signIn")}
											</Button>
											<Button
												type="button"
												className="sign-up-button"
												onClick={() => {
													this.close(index);
													this.setState({ authType: "signup" });
													this.props.toggleAuthPopup(true, "signup");
												}}>
												<SignUpIcon /> {translate("signin-signup.signUp")}
											</Button>
										</SignButtonWrapper>
									) : null}
									{x.msg === "PROFILE_UPDATE_REQUIRED_MESSAGE" ? (
										<SignButtonWrapper>
											<Button
												type="primary"
												htmlType="button"
												className="login-button"
												onClick={() => {
													this.handleProfileUpdate(index);
												}}>
												<ProfileIcon /> {translate("GO_TO_PROFILE")}
											</Button>
										</SignButtonWrapper>
									) : null}
									<ButtonWrapper single={!x.isConfirm}>
										{x.isConfirm ? (
											<Fragment>
												<AlertButton
													onClick={this.onAccept.bind(this, index, x)}>
													{translate("YES")}
												</AlertButton>
												<AlertButton onClick={this.close.bind(this, index)}>
													{translate("NO")}
												</AlertButton>
											</Fragment>
										) : null}
									</ButtonWrapper>
								</AlertWrapper>
								{!x.persistent && (
									<CloseIcon onClick={this.close.bind(this, index)} />
								)}
							</Modal>
						);
					})}
			</Fragment>
		);
	}
}

//Redux stuff
const mapStateToProps = (state) => {
	return {
		alert: state.alert,
		translate: getTranslate(state.localize),
		languages: getLanguages(state.localize),
		currentLanguage: getActiveLanguage(state.localize).code,
	};
};
const mapDispatchToProps = {
	hideAlert,
	toggleAuthPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(Alert);
